import React, { useEffect, useState } from "react";
const fixed = (v, digits = 2) => {
    const n = Number(v);
    return Number.isFinite(n) ? n.toFixed(digits) : (0).toFixed(digits);
};
const cartonsOf = (item) => {
    const unite = Number(item?.product?.unite);
    const qty = Number(item?.quantity) || 0;
    return unite ? qty / unite : qty;
};

const BcProductTable = ({ date, data }) => {
    const [cartonTotal, setCartonTotal] = useState(0);

    const handlePrint = () => {
        // Get the div you want to print
        const divToPrint = document.getElementById("bon-sortie");
        if (!divToPrint) {
            console.error("Element with id 'bon-sortie' not found.");
            return;
        }

        // Open a new window
        const newWin = window.open("", "PrintWindow", "width=800,height=600");

        // Add styles to the new window for proper formatting


        // Write the content to the new window
        newWin.document.write(`
        <html>
            <head>
                <title>Bon sortie</title>
            
            </head>
            <body>
                ${divToPrint.outerHTML}
            </body>
        </html>
    `);

        // Wait for the content to load before printing
        setTimeout(() => {
            newWin.print();
            newWin.close(); // Optional: Close the window after printing
        }, 1000);
    };
    const [contentTable, setContentTable] = useState([]);

    useEffect(() => {
        let tablein = [];
        tablein = Array.isArray(data?.success) ? data.success : [];

        tablein.sort((a, b) => new Date(a?.product?.creationDate) - new Date(b?.product?.creationDate));
        console.log("tablein", tablein)
        setContentTable(tablein);
        // Calculate the total cartons
        const total = tablein.reduce((sum, item) => sum + cartonsOf(item), 0);
        setCartonTotal(fixed(total));
    }, [])
    function calculateCarton(item) {
        return fixed(cartonsOf(item));
    }
    const th = { border: "1px solid #444", padding: "6px 8px", backgroundColor: "#f2f2f2" };
    const td = { border: "1px solid #444", padding: "4px 8px" };
    const kpis = [
        { label: "Produits", value: Array.isArray(contentTable) ? contentTable.length : 0, icon: "fas fa-box", color: "#343a40" },
        { label: "Total des colis", value: cartonTotal, icon: "fas fa-boxes", color: "#17a2b8" },
    ];
    return (
        <div>
            <div className="row mt-3">
                {kpis.map((k) => (
                    <div className="col-lg col-md-4 col-sm-6" key={k.label}>
                        <div
                            className="d-flex align-items-center p-3 mb-3 bg-white"
                            style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)", borderLeft: `4px solid ${k.color}` }}
                        >
                            <span
                                className="d-flex align-items-center justify-content-center text-white mr-3"
                                style={{ width: 44, height: 44, borderRadius: 8, backgroundColor: k.color }}
                            >
                                <i className={k.icon}></i>
                            </span>
                            <div>
                                <small className="text-muted text-uppercase d-block" style={{ fontWeight: 600, letterSpacing: "0.03em" }}>
                                    {k.label}
                                </small>
                                <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>{k.value}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="card card-outline card-dark" style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}>
                <div className="card-header d-flex align-items-center justify-content-between">
                    <h3 className="card-title">
                        <i className="fas fa-list mr-2"></i>Les produits
                    </h3>
                    <button className="btn btn-dark btn-sm" onClick={handlePrint}>
                        <i className="fas fa-print mr-1"></i> Imprimer
                    </button>
                </div>
                <div className="card-body table-responsive">
                    {/* Printed block: inline styles only (copied into the print window) */}
                    <div id="bon-sortie" style={{ fontFamily: "Arial, sans-serif", fontSize: "12px" }}>
                        <h3 style={{ textAlign: "center", marginBottom: "10px" }}>Les produits</h3>
                        <p style={{ margin: "0 0 6px 0" }}>Total des colis: {cartonTotal}</p>
                        <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center" }}>
                            <thead>
                                <tr>
                                    <th style={{ ...th, textAlign: "left" }}>Désignation</th>
                                    <th style={th}>Quantité</th>
                                    <th style={th}>Cartons</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(contentTable) &&
                                    contentTable.map((item, index) => (
                                        <tr key={index} style={{ backgroundColor: index % 2 ? "#fafafa" : "#fff" }}>
                                            <td style={{ ...td, textAlign: "left" }}>{item?.product?.name}</td>
                                            <td style={td}>{fixed(item?.quantity)}</td>
                                            <td style={td}>{calculateCarton(item)}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BcProductTable;
